module.exports = __webpack_public_path__ + "ceddd5ac435a211eb00cdae2f67e60e4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/frog-prince.png
// module id = 2843
// module chunks = 0